// @ts-nocheck
// CAMINHO: src/services/datajudApi.ts (VERSÃO COM PROTEÇÃO)

import { ProcessData, DatajudApiResponse } from '../types/datajud';
import { getDatajudAlias, datajudSearchUrl } from '@/utils/datajudTribunal';

class DatajudApiService {
  private readonly apiKey = 'APIKey cDZHYzlZa0JadVREZDJCendQbXY6SkJlTzNjLV9TRENyQk1RdnFKZGRQdw==';
  
  private getTribunalAlias(processNumber: string): string {
    return getDatajudAlias(processNumber) || 'tjpe';
  }

  public async searchByProcessNumber(numeroProcesso: string): Promise<DatajudApiResponse> {
    // ✅ LINHA DE DEFESA ADICIONADA AQUI
    if (!numeroProcesso) {
      console.error("searchByProcessNumber foi chamado com um valor nulo ou vazio.");
      return { success: false, error: "Número do processo não fornecido." };
    }

    // Limpar número mantendo apenas dígitos, mas preservando a estrutura CNJ
    const numeroLimpo = numeroProcesso.replace(/[^\d]/g, '');
    const tribunal = this.getTribunalAlias(numeroLimpo);
    
    // Tentar diferentes formatos de busca
    const formatosBusca = [
      numeroLimpo, // Número limpo completo
      numeroProcesso, // Número original com formatação
      numeroProcesso.replace(/[.-]/g, ''), // Sem pontos e hífens
    ];

    // Tribunais para tentar (começando com o detectado)
    const tribunaisParaTentar = [
      tribunal, // Tribunal detectado primeiro
      'tjpe', // PE (se não foi detectado)
    ].filter((t, index, arr) => arr.indexOf(t) === index); // Remove duplicatas

    console.log('🔍 Datajud API Debug:');
    console.log('- Número original:', numeroProcesso);
    console.log('- Número limpo:', numeroLimpo);
    console.log('- Tribunal detectado:', tribunal);
    console.log('- Formatos de busca:', formatosBusca);
    console.log('- Tribunais para tentar:', tribunaisParaTentar);

    // Tentar cada tribunal e cada formato
    for (let tribunalIndex = 0; tribunalIndex < tribunaisParaTentar.length; tribunalIndex++) {
      const tribunalAtual = tribunaisParaTentar[tribunalIndex];
      console.log(`\n🏛️ Tentando tribunal: ${tribunalAtual}`);
      
      for (let formatoIndex = 0; formatoIndex < formatosBusca.length; formatoIndex++) {
        const formatoAtual = formatosBusca[formatoIndex];
        const urlAtual = datajudSearchUrl(tribunalAtual, `numeroProcesso:${formatoAtual}`);
        
        console.log(`- Tentativa ${tribunalIndex + 1}.${formatoIndex + 1}: ${formatoAtual}`);
        console.log(`- URL: ${urlAtual}`);

        try {
          const res = await fetch(urlAtual, {
            method: 'GET',
            headers: { 
              'Authorization': this.apiKey, 
              'Content-Type': 'application/json' 
            }
          });

          console.log(`- Status da resposta (${tribunalAtual}):`, res.status);

          if (!res.ok) {
            if (res.status === 401) throw new Error("A chave de API é inválida ou expirou.");
            if (res.status === 405) throw new Error("Método não permitido. Verificando configuração da API.");
            throw new Error(`Erro no servidor do tribunal (Status: ${res.status})`);
          }
          
          const data = await res.json();
          const hits = data?.hits?.hits || [];
          console.log(`- Hits encontrados (${tribunalAtual}):`, hits.length);
          
          if (hits.length > 0) {
            const processData = hits.map((hit: any) => this.mapRawDataToProcess(hit._source));
            console.log('✅ Dados encontrados!', processData);
            
            return { 
              success: true, 
              data: processData, 
              pagination: { totalResults: data.hits.total.value } 
            };
          }
          
          // Se não encontrou resultados, continuar para próximo formato
          console.log(`- Nenhum resultado no ${tribunalAtual}, tentando próximo formato...`);
          
        } catch (error: any) {
          console.error(`Erro no ${tribunalAtual}:`, error);
          // Continuar para próxima tentativa
          continue;
        }
      }
    }

    // Se chegou aqui, nenhum tribunal/formato funcionou
    console.log('❌ Nenhum tribunal/formato retornou resultados');
    return { 
      success: false, 
      error: "Nenhum dado encontrado para este processo em nenhum tribunal do Datajud" 
    };
  }

  private mapRawDataToProcess(source: any): ProcessData {
    return {
      numeroProcesso: source.numeroProcesso || 'Não informado',
      tribunal: source.tribunal || 'N/I',
      orgaoJulgador: source.orgaoJulgador?.nome || 'Não informado',
      classe: source.classe || { nome: 'Não informada', codigo: 0 },
      assunto: source.assuntos?.flat() || [],
      dataAjuizamento: source.dataAjuizamento,
      partes: (source.partes || []).map((p: any) => ({
        nome: p.pessoa?.nome || p.nome || 'Parte não identificada',
        tipo: p.tipoParticipacao || 'N/I',
        polo: p.polo,
      })),
      movimentacoes: (source.movimentos || []).map((m: any) => ({
        dataHora: m.dataHora,
        nome: m.movimentoNacional?.nome || m.nome,
        complemento: m.complemento,
      }))
    };
  }
}

export const datajudApi = new DatajudApiService();